<template>
    <div class="bg-white rounded">
        <div class="table pt-3 mb-0">
            <div class="add_license d-flex justify-content-between align-items-center flex-wrap mb-2 px-3">
                <h3 class="font-weight-bold f-20 text-left mb-0 text-black">{{ $t('customFields.title') }}</h3>
                <div class="d-flex align-items-center flex-wrap" v-if="allowAddDriver || allowCreateEquipment">
                    <b-button @click="openCreate()"
                        class="export equipment d-flex justify-content-center align-items-center w-fit-content"
                        variant="primary">
                        <b-icon icon="plus" class="p-0" aria-hidden="true"></b-icon>
                        <p class="mb-0 ml-2 text-white p-0">{{ $t('customFields.addCustomField') }}</p>
                    </b-button>
                </div>
            </div>
            <v-tabs class="team-tabs custom-fields-tab mb-0 border-0" v-if="isTableMounted" show-arrows v-model="activeTab">
                <v-tab @click="setActiveModel('driver')">{{ $t('customFields.driver') }} <span class="f-12 ml-1">({{
                    driverCount }})</span></v-tab>
                <v-tab @click="setActiveModel('vehicle')">{{ $t('customFields.vehicle') }} <span class="f-12 ml-1">({{
                    vehicleCount }})</span></v-tab>
                <v-tab @click="setActiveModel('trailer')">{{ $t('customFields.trailer') }} <span class="f-12 ml-1">({{
                    trailerCount }})</span></v-tab>
            </v-tabs>
            <b-table :sticky-header="'calc(100vh - 310px)'" ref="sortableTable" responsive :fields="translatedFields"
                :items="filteredItems" hover :per-page="perPage" :current-page="currentPage" show-empty>
                <template #head(sort)="">
                    <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="2" cy="16" r="2" transform="rotate(-90 2 16)" fill="#C4C4C4" />
                        <circle cx="2" cy="9" r="2" transform="rotate(-90 2 9)" fill="#C4C4C4" />
                        <circle cx="2" cy="2" r="2" transform="rotate(-90 2 2)" fill="#C4C4C4" />
                    </svg>
                </template>
                <template #cell(sort)="data">
                    <svg v-if="allowUpdateItem(data.item)" class="sortable-handle" width="4" height="18" viewBox="0 0 4 18" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="2" cy="16" r="2" transform="rotate(-90 2 16)" fill="#C4C4C4" />
                        <circle cx="2" cy="9" r="2" transform="rotate(-90 2 9)" fill="#C4C4C4" />
                        <circle cx="2" cy="2" r="2" transform="rotate(-90 2 2)" fill="#C4C4C4" />
                    </svg>
                </template>
                <template #cell(model)="data">
                    <span>{{ translateModel(data.item.model) }}</span>
                </template>
                <template #cell(field_type)="data">
                    <span>{{ translateFieldType(data.item.field_type) }}</span>
                </template>
                <template #cell(options)="data">
                    <div v-if="data.item.options && data.item.options.length" class="d-flex flex-wrap">
                        <span> {{ data.item.options.join(', ') }}
                        </span>
                    </div>
                    <span v-else>-</span>
                </template>
                <template #cell(action)="data">
                    <div>
                        <svg  v-if="allowUpdateItem(data.item)" @click="editFieldItem(data.item)" class="mr-4 cursor-pointer" width="18" height="18"
                            viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
                                fill="#2CCE89" />
                        </svg>
                        <svg v-if="allowDeleteItem(data.item)" @click="showFieldDeletePopup(data.item.id)" class="cursor-pointer" width="19" height="20"
                            viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                </template>
            </b-table>
            <div class="entries-pagination px-0 px-sm-2">
                <div class="d-flex align-items-center flex-wrap">
                    <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                        <b-form-select v-model="perPage" :options="pageOptions" />
                    </div>
                    <div class="pagination">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                            aria-controls="my-table"></b-pagination>
                    </div>
                    <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">
                        {{ positionText }}
                    </p>
                </div>
            </div>
        </div>
        <b-modal id="custom-field-modal" centered no-close-on-backdrop no-close-on-esc
            :body-class="'px-3 pt-2 overflow-preview-auto'" :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
            :header-class="'align-items-center'" scrollable>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ editing ? $t('customFields.editCustomField') : $t('customFields.addCustomField') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="body">
                <b-row>
                    <b-col cols="12" class="mt-3">
                        <b-form-group :label="$t('customFields.nameLabel')" class="text-left mb-0">
                            <b-form-input v-model="form.name" :placeholder="$t('customFields.namePlaceholder')" class="unit"
                                required></b-form-input>
                            <p v-if="errors && errors.name" class="field-error">
                                {{ errors.name[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" class="mt-3">
                        <b-form-group :label="$t('customFields.modelLabel')" class="text-left mb-0">
                            <b-form-select v-model="form.model" :options="modelSelectOptions" :disabled="editing"
                                class="f-12" />
                            <p v-if="errors && errors.model" class="field-error">
                                {{ errors.model[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" class="mt-3">
                        <b-form-group :label="$t('customFields.fieldTypeLabel')" class="text-left mb-0">
                            <b-form-select v-model="form.field_type" :options="fieldTypeSelectOptions" :disabled="editing"
                                class="f-12" />
                            <p v-if="errors && errors.field_type" class="field-error">
                                {{ errors.field_type[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" class="mt-3" v-if="needsOptions">
                        <b-form-group :label="$t('customFields.optionsLabel')" class="text-left mb-0">
                            <div v-for="(_, index) in form.options" :key="index"
                                class="d-flex align-items-center mb-2 option-row">
                                <b-form-input v-model="form.options[index]"
                                    :placeholder="$t('customFields.optionPlaceholder', { index: index + 1 })"
                                    class="unit f-12 flex-grow-1"></b-form-input>
                                <svg :disabled="form.options.length <= 1" @click="removeOption(index)" width="19"
                                    height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                                    class="cursor-pointer ml-2 option-btn d-flex align-items-center justify-content-center">
                                    <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                    <path
                                        d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                    </path>
                                    <path
                                        d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                    </path>
                                    <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </div>
                            <b-button @click="addOption"
                                class="export equipment d-flex justify-content-center align-items-center w-fit-content"
                                variant="primary">
                                <b-icon icon="plus" class="p-0" aria-hidden="true"></b-icon>
                                <p class="mb-0 ml-2 text-white p-0">{{ $t('customFields.add') }}</p>
                            </b-button>
                            <p v-if="errors && errors.options" class="field-error">
                                {{ errors.options[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0">
                    <b-button class="mx-0 h-40px w-100px m-0 mr-3" @click="resetForm()" variant="secondary">{{
                        $t('customFields.cancel') }}</b-button>
                    <div class="d-flex align-items m-0">
                        <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="saveField()">{{
                            $t('customFields.save') }}</b-button>
                    </div>
                </div>
            </template>
        </b-modal>
        <DeleteModal v-if="showDeletePopup" @confirm="deleteItem($event)" />
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import DeleteModal from "@/components/DeleteModal.vue";
export default {
    name: "CustomFields",
    components: { DeleteModal },
    data() {
        return {
            items: [],
            editing: false,
            perPage: 50,
            currentPage: 1,
            fieldID: null,
            showDeletePopup: false,
            isTableMounted: false,
            activeTab: 0,
            activeModel: 'driver',
            modelFilter: null,
            pageOptions: [
                { value: 10, text: "10" },
                { value: 25, text: "25" },
                { value: 50, text: "50" },
                { value: 100, text: "100" },
            ],
            form: {
                name: "",
                model: null,
                field_type: null,
                options: [""],
            },
            errors: {},
        }
    },
    computed: {
        ...mapGetters(["customFields", "userCompany", "rolePermissions"]),
        translatedFields() {
            return [
                { key: "sort", label: "", thStyle: { minWidth: "20px", width: "20px" }, thClass: 'font-table-weight-bold' },
                { key: "name", label: this.$t('customFields.nameColumn'), sortable: false, thClass: 'font-table-weight-bold' },
                { key: "model", label: this.$t('customFields.modelColumn'), sortable: false, thClass: 'font-table-weight-bold' },
                { key: "field_type", label: this.$t('customFields.fieldTypeColumn'), sortable: false, thClass: 'font-table-weight-bold' },
                { key: "options", label: this.$t('customFields.optionsColumn'), sortable: false, thClass: 'font-table-weight-bold' },
                { key: "Action", sortable: false, thClass: 'font-table-weight-bold' },
            ];
        },
        allowAddDriver() {
            return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][3].allow
        },
        allowUpdateDriver() {
            return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][2].allow
        },
        allowDeleteDriver() {
            return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][5].allow
        },
        allowCreateEquipment() {
            return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][2].allow
        },
        allowUpdateEquipment() {
            return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][1].allow
        },
        allowDeleteEquipment() {
            return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][3].allow
        },
        modelSelectOptions() {
            return [
                { value: null, text: this.$t('customFields.selectModel'), disabled: true },
              ...((this.allowAddDriver && !this.editing) || (this.allowUpdateDriver && this.editing) ? [{ value: "driver", text: this.$t('customFields.driver') }] : []),
              ...((this.allowCreateEquipment && !this.editing) || (this.allowUpdateEquipment && this.editing) ? [{ value: "vehicle", text: this.$t('customFields.vehicle') }] : []),
              ...((this.allowCreateEquipment && !this.editing) || (this.allowUpdateEquipment && this.editing) ? [{ value: "trailer", text: this.$t('customFields.trailer') }] : []),
            ];
        },
        fieldTypeSelectOptions() {
            return [
                { value: null, text: this.$t('customFields.selectFieldType'), disabled: true },
                { value: "text", text: this.$t('customFields.fieldTypeText') },
                { value: "number", text: this.$t('customFields.fieldTypeNumber') },
                { value: "date", text: this.$t('customFields.fieldTypeDate') },
                { value: "select", text: this.$t('customFields.fieldTypeSelect') },
                { value: "multi_select", text: this.$t('customFields.fieldTypeMultiSelect') },
            ];
        },
        filteredItems() {
            return this.items.filter(i => i.model === this.activeModel);
        },
        rows() {
            return this.filteredItems.length;
        },
        driverCount() {
            return this.items.filter(i => i.model === 'driver').length;
        },
        vehicleCount() {
            return this.items.filter(i => i.model === 'vehicle').length;
        },
        trailerCount() {
            return this.items.filter(i => i.model === 'trailer').length;
        },
        needsOptions() {
            return this.form.field_type === 'select' || this.form.field_type === 'multi_select';
        },
        positionText() {
            const endIndex = this.currentPage * this.perPage;
            const startIndex = this.rows > 0 ? (this.currentPage - 1) * this.perPage + 1 : 0;
            const end = endIndex > this.rows ? this.rows : endIndex;
            return this.$t('customFields.positionText', { start: startIndex, end, total: this.rows });
        }
    },
    methods: {
        ...mapActions(['getCustomFields', 'addCustomField', 'updateCustomField', 'deleteCustomField', 'setNotification', 'setLoader']),
        allowDeleteItem(item) {
            if (!item || !item.model) return false;
            if (item.model === 'driver') return this.allowDeleteDriver;
            if (item.model === 'vehicle') return this.allowDeleteEquipment;
            if (item.model === 'trailer') return this.allowDeleteEquipment;
            return false;
        },
        allowUpdateItem(item) {
            if (!item || !item.model) return false;
            if (item.model === 'driver') return this.allowUpdateDriver;
            if (item.model === 'vehicle') return this.allowUpdateEquipment;
            if (item.model === 'trailer') return this.allowUpdateEquipment;
            return false;
        },
        formatFieldType(type) {
            if (!type) return '';
            return type.replace('_', ' ');
        },
        translateModel(model) {
            const map = { driver: 'customFields.driver', vehicle: 'customFields.vehicle', trailer: 'customFields.trailer' };
            return map[model] ? this.$t(map[model]) : model;
        },
        translateFieldType(type) {
            const map = {
                text: 'customFields.fieldTypeText',
                number: 'customFields.fieldTypeNumber',
                date: 'customFields.fieldTypeDate',
                select: 'customFields.fieldTypeSelect',
                multi_select: 'customFields.fieldTypeMultiSelect',
            };
            return map[type] ? this.$t(map[type]) : this.formatFieldType(type);
        },
        cleanOptions(opts) {
            if (!Array.isArray(opts)) return [];
            return opts.map(s => (s == null ? '' : String(s).trim())).filter(Boolean);
        },
        addOption() {
            this.form.options.push("");
        },
        removeOption(index) {
            if (this.form.options.length <= 1) return;
            this.form.options.splice(index, 1);
        },
        async getFields() {
            try {
                await this.getCustomFields();
                this.items = (this.customFields || []).map(f => ({
                    id: f.id,
                    name: f.name,
                    model: f.model,
                    field_type: f.field_type,
                    options: Array.isArray(f.options) ? f.options : [],
                    order: f.order != null ? f.order : 0,
                })).sort((a, b) => (a.order || 0) - (b.order || 0));
                this.isTableMounted = true;
                this.$nextTick(() => this.initSortable());
            } catch (e) {
                await this.setNotification({
                    msg: typeof e === 'string' ? e : (e && e.detail) || this.$t('customFields.loadFailed'),
                    type: 'error',
                    color: 'red',
                });
            }
        },
        setActiveModel(model) {
            this.activeModel = model;
            this.currentPage = 1;
        },
        openCreate() {
            this.form.model = this.activeModel;
            this.$bvModal.show('custom-field-modal');
        },
        editFieldItem(item) {
            this.editing = true;
            this.fieldID = item.id;
            const opts = Array.isArray(item.options) && item.options.length ? [...item.options] : [""];
            this.form = {
                name: item.name || "",
                model: item.model,
                field_type: item.field_type,
                options: opts,
            };
            this.errors = {};
            this.$bvModal.show('custom-field-modal');
        },
        resetForm() {
            this.$bvModal.hide('custom-field-modal');
            this.editing = false;
            this.fieldID = null;
            this.form = { name: "", model: null, field_type: null, options: [""] };
            this.errors = {};
        },
        initSortable() {
            if (!this.$refs.sortableTable || !window.Sortable) return;
            const tableBody = this.$refs.sortableTable.$el.querySelector('tbody');
            if (!tableBody || tableBody._sortableInstance) return;
            tableBody._sortableInstance = window.Sortable.create(tableBody, {
                animation: 150,
                handle: '.sortable-handle',
                onEnd: async (evt) => {
                    if (evt.oldIndex === evt.newIndex) return;
                    const tbody = evt.from;
                    const movedNode = evt.item;
                    movedNode.parentNode.removeChild(movedNode);
                    const referenceNode = tbody.children[evt.oldIndex] || null;
                    tbody.insertBefore(movedNode, referenceNode);

                    const reordered = [...this.filteredItems];
                    const [moved] = reordered.splice(evt.oldIndex, 1);
                    reordered.splice(evt.newIndex, 0, moved);
                    reordered.forEach((item, idx) => { item.order = idx + 1; });
                    const others = this.items.filter(i => i.model !== this.activeModel);
                    this.items = [...others, ...reordered].sort((a, b) => (a.order || 0) - (b.order || 0));

                    try {
                        await Promise.all(reordered.map((item, idx) =>
                            this.updateCustomField({ id: item.id, payload: { order: idx + 1 } })
                        ));
                    } catch (e) {
                        await this.setNotification({
                            msg: typeof e === 'string' ? e : this.$t('customFields.reorderFailed'),
                            type: 'error',
                            color: 'red',
                        });
                        await this.getFields();
                    }
                },
            });
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (key === 'options' && this.needsOptions) {
                    if (!value || (Array.isArray(value) && value.length === 0)) {
                        nullKeys.push(key);
                    }
                }
                else
                    if (!value) {
                        nullKeys.push(key);
                    }
            }
            return nullKeys;
        },

        async saveField() {
            try {
                this.errors = {}
                const cleanedOptions = this.needsOptions ? this.cleanOptions(this.form.options) : [];
                const nullKeys = this.checkNullValues({
                    name: this.form.name,
                    field_type: this.form.field_type,
                    ...(this.needsOptions ? { options: cleanedOptions } : {})
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true);
                    const modelCount = this.items.filter(i => i.model === this.form.model).length;
                    const payload = {
                        name: this.form.name.trim(),
                        model: this.form.model,
                        field_type: this.form.field_type,
                        options: cleanedOptions,
                        order: modelCount + 1,
                    };
                    const successMsg = this.editing ? this.$t('customFields.fieldUpdated') : this.$t('customFields.fieldAdded');
                    try {
                        if (this.editing) {
                            const updatePayload = { name: payload.name, options: payload.options };
                            await this.updateCustomField({ id: this.fieldID, payload: updatePayload });
                        } else {
                            await this.addCustomField(payload);
                        }
                        await this.setNotification({
                            msg: successMsg,
                            type: 'success',
                            color: 'green',
                        });
                        this.resetForm();
                        await this.getFields();
                    }
                    catch (e) {
                        this.setLoader(false)
                        await this.setNotification({
                            msg: e,
                            type: "error",
                            color: "red",
                        });
                        return
                    }
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('customFields.fieldRequired')];
                    });
                    throw error;
                }
            }


            catch (error) {
                this.setLoader(false);
                if (typeof error === "object") {
                    this.errors = error;
                }
            }
        },
        showFieldDeletePopup(id) {
            this.showDeletePopup = true;
            this.fieldID = id;
        },
        async deleteItem(status) {
            if (!status) {
                this.showDeletePopup = false;
                return;
            }
            try {
                await this.deleteCustomField(this.fieldID);
                await this.setNotification({
                    msg: this.$t('customFields.fieldDeleted'),
                    type: 'success',
                    color: 'green',
                });
                this.fieldID = null;
                this.showDeletePopup = false;
                await this.getFields();
            } catch (e) {
                this.fieldID = null;
                this.showDeletePopup = false;
                await this.setNotification({
                    msg: typeof e === 'string' ? e : (e && (e.detail || e.error)) || this.$t('customFields.deleteFailed'),
                    type: 'error',
                    color: 'red',
                });
            }
        },
    },
    async mounted() {
        await this.getFields();
    }
}
</script>
<style scoped>
.option-row .option-btn {
    padding: 0;
    flex-shrink: 0;
}
</style>
<style>
.custom-fields-tab .v-item-group .v-slide-group__wrapper {
    padding: 0px !important
}
</style>
